module.exports = " <div class=sharke @click=hideEvent style=display:block><img :src=share.url alt=\"\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ShareMask.vue
// module id = 149
// module chunks = 0